import { render, staticRenderFns } from "./logwood-history-inventory.vue?vue&type=template&id=38719cf3&scoped=true&"
import script from "./logwood-history-inventory.vue?vue&type=script&lang=ts&"
export * from "./logwood-history-inventory.vue?vue&type=script&lang=ts&"
import style0 from "./logwood-history-inventory.vue?vue&type=style&index=0&id=38719cf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38719cf3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VSpacer})
